import Util from "ips/ac/util/Util";

export default {
  getTasksText(total: number, checked: number): string {
    if (total === 0) {
      return Util.getText("@InternalOrderStatus_Dialog_Table_Content_NoteIsNotPresent");
    }

    return `${checked}/${total}`;
  },

  isTasksIconVisible(htmlText: string): boolean {
    return !!htmlText && this.getCheckListStats(htmlText).total > 0;
  },

  getTasksIcon(htmlText: string): string | null {
    const { total, checked } = this.getCheckListStats(htmlText);
    if (total === 0) {
      return null;
    }

    if (checked === total) {
      return "sap-icon://complete";
    }
  },

  getTasksIconColor() {
  },

  getCheckListStats(htmlText: string): { total: number, checked: number } {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, "text/html");
    const checklistItems = doc.querySelectorAll("li.tox-checklist-item");
    return {
      total: checklistItems.length,
      checked: Array.from(checklistItems).filter(item => item.getAttribute("data-checked") === "true").length,
    };
  },
};